import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseResourceFormComponent, Convenio, ConvenioAditamento, ConvenioAlteracao, ConvenioComissao, ConvenioHistorico, ConvenioReajuste, ConvenioRecurso, ConvenioSituacao, ConvenioStorage, DateFormatPipe,
  EddyAutoComplete, Favorecido, FavorecidoService, GlobalService, Licitacao, LoginContabil, Recurso, Recebimento, TipoConvenio, Unidade, UnidadeService
} from 'eddydata-lib';
import { ConvenioService } from '../service/convenio.service';
import { RecursoService } from '../../../contabil/recurso/service/recurso.service';
import { takeUntil } from 'rxjs/operators';
import { MessageService, SelectItem } from 'primeng/api';
import { ConvenioPrestacaoService } from '../service/convenio-prestacao.service';
import { ConvenioComissaoService } from '../convenio-comissao/service/convenio-comissao.service';
import { TipoConvenioService } from '../../tipo-convenio/service/tipo-convenio.service';
import { ConvenioHistoricoService } from '../service/convenio-historico.service';
import { ConvenioAditamentoService } from '../service/convenio-aditamento.service';
import { ConvenioSituacaoService } from '../service/convenio-situacao.service';
import { ConvenioAlteracaoService } from '../convenio-alteracao/service/convenio-alteracao.service';
import { ConvenioReajusteService } from '../service/convenio-reajuste.service';
import { EmpenhoRestoService, FichaDespesaService, FichaReceitaService, RecebimentoService } from 'contabil-lib';
import { ConvenioRecursoService } from '../convenio-recurso/service/convenio-recurso.service';
import { ConvenioStorageService } from '../service/convenio-storage.service';
import { EmpenhoService } from 'administrativo-lib';
import { error, success } from 'toastr';

@Component({
  selector: 'lib-convenio-frm',
  templateUrl: './convenio-frm.component.html'
})
export class ConvenioFrmComponent extends BaseResourceFormComponent<Convenio, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  public unidadeAutoComplete: EddyAutoComplete<Unidade>;
  public listaHistoricos: Array<ConvenioHistorico> = new Array<any>();
  public listaAditamentos: Array<ConvenioAditamento> = new Array<any>();
  public favorecidoAutoComplete: EddyAutoComplete<Favorecido>;
  public recursoAutoComplete: EddyAutoComplete<Recurso>;
  public aplicacaoAutoComplete: EddyAutoComplete<Recurso>;
  public aplicacaoVariavelAutoComplete: EddyAutoComplete<Recurso>;
  public recursoContraAutoComplete: EddyAutoComplete<Recurso>;
  public aplicacaoContraAutoComplete: EddyAutoComplete<Recurso>;
  public aplicacaoVariavelContraAutoComplete: EddyAutoComplete<Recurso>;
  public listaComissoes: Array<ConvenioComissao> = new Array<any>();
  public listaTipoConvenio: TipoConvenio[];
  public listaAlteracoes: ConvenioAlteracao[];
  public listaTipoFavorecido: Array<any> = []
  public listaFichasDespesas: Array<any> = []
  public listaFichasReceitas: Array<any> = []
  public listaOrigem: Array<any> = []
  public listaEspecie: Array<any> = []
  public listaLegislacao: Array<any> = []
  public listaSituacoes: Array<any> = []
  public listaRecursos: Array<any> = []
  public listaStorage: ConvenioStorage[];
  public liquidacoes: Array<{ id: number, resto: boolean }> = [];
  public pagamentos: Array<{ id: number, especie: string }> = [];
  public recebimentos: Recebimento[] = [];
  public listaReajustes: Array<ConvenioReajuste> = new Array<any>();
  public listaLicitacoes: Array<Licitacao> = new Array<any>();
  public itens: SelectItem[];
  public selectedItem: any;
  public tipoConvenioPossuiOrigem: boolean = false;
  public bloquearOrigemPeloRecurso: boolean = false;
  public paginaTotalRecebimento: number;
  public paginaCorrenteRecebimento: number = 1;
  public limiteRecebimento: number = 20;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    protected messageService: MessageService,
    protected globalService: GlobalService,
    protected prestacaoService: ConvenioPrestacaoService,
    protected unidadeService: UnidadeService,
    protected convenioService: ConvenioService,
    protected comissaoService: ConvenioComissaoService,
    protected historicoService: ConvenioHistoricoService,
    protected aditamentoService: ConvenioAditamentoService,
    protected recursoService: RecursoService,
    protected tipoConvenioService: TipoConvenioService,
    protected situacaoService: ConvenioSituacaoService,
    protected alteracaoService: ConvenioAlteracaoService,
    protected reajusteService: ConvenioReajusteService,
    protected recebimentoService: RecebimentoService,
    protected fichaReceitaService: FichaReceitaService,
    protected fichaDespesaService: FichaDespesaService,
    protected convenioStorageService: ConvenioStorageService,
    protected convenioRecursoService: ConvenioRecursoService,
    protected empenhoRestoService: EmpenhoRestoService,
    protected empenhoService: EmpenhoService,
    protected favorecidoService: FavorecidoService) {
    super(new Convenio(), injector, Convenio.converteJson, convenioService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected async podeAlterar(_entidade: Convenio): Promise<boolean> {
    return this.login.sistema != 'controle-interno' && this.login.sistema != 'indicador-gestao';
  }

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      numero: [null, [Validators.required]],
      ano: [this.login.exercicio.ano, Validators.required],
      unidade: [null, [Validators.required]],
      processo: ['', [Validators.required]],
      especie: ['D', [Validators.required]],
      origem: [null, [Validators.required]],
      siconv: [null],
      objeto: [null, [Validators.required]],
      finalidade: [null, [Validators.required]],
      aditivo: [null],
      lei_numero: [null],
      tipo_convenio: ['4', [Validators.required]],
      legislacao: ['0', [Validators.required]],
      enviar_email: [null],
      autorizacao: ['', [Validators.required]],
      data_assinatura: [null, [Validators.required]],
      data_contabilizacao: [null, [Validators.required]],
      data_inicio: [null, [Validators.required]],
      data_termino: [null],
      data_prestacao: [null],
      data_quitacao: [null],
      tipo_fornecedor: [null, [Validators.required]],
      valor_convenio: 0,
      valor_contrapartida: 0,
      saldo_anterior: [null],
      valor_aplicacao: [null],
      valor_devolvido: [null],
      valor_outros: [null],
      valor_recurso: [null],
      valor_convenente: [0],
      numero_convenio: [null],
      arquivo_morto: [null],
      observacao: [null],
      recurso: [null, [Validators.required]],
      aplicacao: [null, [Validators.required]],
      aplicacao_variavel: [null, [Validators.required]],
      recurso_contra: [null],
      aplicacao_contra: [null],
      aplicacao_variavel_contra: [null],
      favorecido: [null, [Validators.required]],
      orgao: [this.login.orgao, [Validators.required]],
      exercicio: [this.login.exercicio, [Validators.required]],
      exercicio_logado: [this.login.exercicio],
      parente: [null],
      prestacoes: [null],
      comissoes: [null],
      historicos: [null],
      aditamentos: [null],
      recursos: [[]],
      situacoes: [null],
      ativo: [false],
      nao_salvar_recursos: [null]
    });
  }

  protected async afterLoad() {
    this.entidade.data_assinatura = new DateFormatPipe().transform(this.entidade.data_assinatura, []);
    this.entidade.data_inicio = new DateFormatPipe().transform(this.entidade.data_inicio, []);
    this.entidade.data_termino = new DateFormatPipe().transform(this.entidade.data_termino, []);
    this.entidade.data_contabilizacao = new DateFormatPipe().transform(this.entidade.data_contabilizacao, []);
    this.favorecidoAutoComplete.id = this.entidade.favorecido ? this.entidade.favorecido.id : null;
    this.recursoAutoComplete.id = this.entidade.recurso ? this.entidade.recurso.id : null;
    this.aplicacaoAutoComplete.id = this.entidade.aplicacao ? this.entidade.aplicacao.id : null;
    this.aplicacaoVariavelAutoComplete.id = this.entidade.aplicacao_variavel ? this.entidade.aplicacao_variavel.id : null;
    this.entidadeForm.get('data_contabilizacao').disable();
    if (!this.podeAlterarAudesp(this.entidade.data_contabilizacao)) {
      this.entidadeForm.get('data_contabilizacao').disable();
      this.entidadeForm.get('data_assinatura').disable();
      this.entidadeForm.get('valor_convenio').disable();
      this.entidadeForm.get('valor_contrapartida').disable();
      this.entidadeForm.get('origem').disable();
      this.entidadeForm.get('tipo_convenio').disable();
      this.entidadeForm.get('tipo_fornecedor').disable();
      this.entidadeForm.get('numero').disable();
    }

    const param = {};
    param['convenio.id'] = this.entidade.id;

    this.historicoService.filtrar(0, -1, param).pipe(takeUntil(this.unsubscribe)).subscribe((data: any) => {
      this.listaHistoricos = data ? data.content : new Array<ConvenioHistorico>();
    }, e => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: e }));

    this.comissaoService.filtrar(0, -1, param).pipe(takeUntil(this.unsubscribe)).subscribe((data: any) => {
      this.listaComissoes = data ? data.content : new Array<ConvenioComissao>();
    }, e => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: e }));

    this.convenioStorageService.filtrar(0, -1, param).pipe(takeUntil(this.unsubscribe)).subscribe((data: any) => {
      this.listaStorage = data ? data.content : new Array<ConvenioStorage>();
    }, e => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: e }));

    this.convenioRecursoService.filtrar(0, -1, param).pipe(takeUntil(this.unsubscribe)).subscribe((data: any) => {
      this.listaRecursos = data ? data.content : new Array<ConvenioRecurso>();
    }, e => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: e }));

    this.itens = [];
    this.itens.push({ label: 'EMPENHOS', value: '1' })
    this.itens.push({ label: 'LIQUIDAÇÕES', value: '2' });
    this.itens.push({ label: 'PAGAMENTOS', value: '3' });
    this.itens.push({ label: 'RECEBIMENTOS', value: '4' });

    this.selectedItem = { label: 'PAGAMENTOS', value: '3' };

    if (['02', '05'].includes(this.entidade.recurso.codigo)) {
      this.bloquearOrigemPeloRecurso = true;
    }

    if (this.entidade.tipo_convenio.origem) {
      this.tipoConvenioPossuiOrigem = true;
    }
  }

  protected parametrosExtras(): {} {
    return {
      relations: 'favorecido,favorecido.tipo,orgao,orgao.cidade,recurso,aplicacao,aplicacao_variavel,unidade,tipo_convenio,recurso_contra,aplicacao_contra,aplicacao_variavel_contra,exercicio'
    };
  }

  protected afterInit(): void {
    this.carregarAutoCompletes();
    this.listaTipoFavorecido = [
      { nome: 'FORNECEDOR', id: 'F' },
      { nome: 'CREDOR', id: 'C' }
    ];
    this.listaOrigem = [
      { nome: 'MUNICIPAL', id: 'M' },
      { nome: 'ESTADUAL', id: 'E' },
      { nome: 'FEDERAL', id: 'U' }
    ];
    this.listaEspecie = [
      { nome: '-', id: 'X' },
      { nome: 'CHAMAMENTO', id: 'C' },
      { nome: 'DISPENSA', id: 'D' },
      { nome: 'INEXIGIBILIDADE', id: 'I' },
      { nome: 'OUTROS', id: 'O' }
    ];
    this.listaLegislacao = [
      { nome: '-', id: '0' },
      { nome: 'LEI FEDERAL', id: '1' },
      { nome: 'LEI ESTADUAL', id: '2' },
      { nome: 'LEI MUNICIPAL', id: '3' },
      { nome: 'DECRETO FEDERAL', id: '4' },
      { nome: 'DECRETO ESTADUAL', id: '5' },
      { nome: 'DECRETO MUNICIPAL', id: '6' }
    ];

    this.tipoConvenioService.filtrar(0, 0, { orgao_id: this.login.orgao.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaTipoConvenio = res ? res.content : [];
      }, e => error(e.message ? e.message : e));

    this.entidadeForm.get('data_contabilizacao').disable()
    if (!this.entidade.id) this.entidadeForm.get('data_contabilizacao').setValue(new Date())
  }

  atualizarSituacao(lista: Array<ConvenioSituacao>) {
    this.listaSituacoes = lista;
    this.entidadeForm.get('nao_salvar_recursos').setValue(true);
    this.salvar(false);
  }

  public incluirAlteracoes(alteracao: ConvenioAlteracao) {
    this.entidade.valor_convenio = alteracao.valor_convenio;
    this.entidade.valor_contrapartida = alteracao.valor_contrapartida;
    this.entidade.data_inicio = alteracao.data_inicio;
    this.entidade.data_termino = alteracao.data_termino;
    if (alteracao.processo) {
      this.entidade.processo = alteracao.processo;
    }
    if (alteracao.tipo_convenio) {
      this.entidade.tipo_convenio = alteracao.tipo_convenio;
    }

    this.convenioService.atualizar(this.entidade).subscribe((dados) => {
      this.entidadeForm.get('valor_convenio').setValue(this.entidade.valor_convenio)
      this.entidadeForm.get('valor_contrapartida').setValue(this.entidade.valor_contrapartida)
      this.entidadeForm.get('data_inicio').setValue(this.entidade.data_inicio)
      this.entidadeForm.get('data_termino').setValue(this.entidade.data_termino)
      if (alteracao.processo) {
        this.entidadeForm.get('processo').setValue(this.entidade.processo)
      }
      if (alteracao.tipo_convenio) {
        this.entidadeForm.get('tipo_convenio').setValue(this.entidade.tipo_convenio)
      }
    },
      (e) => this.messageService.add(
        { severity: 'error', summary: 'Atenção!', detail: e.error && e.error.payload ? e.error.payload : e }
      )
    );
  }

  public verificarDataContabilizacao() {
    let dataContabilizacao: Date = this.entidade.data_contabilizacao;
    if (dataContabilizacao) {
      if (dataContabilizacao < new Date()) {
        return 'disabled';
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  protected beforeSubmit(): void {
    try {
      if (!this.entidadeForm.get('data_contabilizacao').value) {
        throw new Error(`Informe a data de contabilização!`);
      }
      if (!this.entidadeForm.get('numero').value) {
        throw new Error(`Informe o número do convênio!`);
      }
      if (!this.entidadeForm.get('data_assinatura').value) {
        throw new Error(`Informe a data de assinatura!`);
      }
      if (!this.entidadeForm.get('favorecido').value) {
        throw new Error(`Informe o favorecido!`);
      }
      if (!this.entidadeForm.get('finalidade').value) {
        throw new Error(`Informe a finalidade!`);
      }
      if (!this.entidadeForm.get('data_inicio').value) {
        throw new Error(`Informe a data de inicio!`);
      }
      if (!this.entidadeForm.get('processo').value) {
        throw new Error(`Informe o número processo!`);
      }
      if (!this.entidadeForm.get('favorecido').value) {
        throw new Error(`Informe o favorecido para o convênio!`);
      }
      if (!this.entidadeForm.get('orgao').value) {
        throw new Error(`Informe o orgão público do convênio!`);
      }
      if (this.entidadeForm.get('valor_convenio').value && +this.entidadeForm.get('valor_convenio').value == 0) {
        throw new Error(`Informe o valor do convênio`);
      }
      if (!this.podeAlterarAudesp(this.entidadeForm.get('data_contabilizacao').value) && !this.entidade.id) {
        throw new Error(`Data de contabilização não pode se inferior a ${this.login['dias_bloquear_alteracoes']} dia(s)`);
      }

      let recursoPrincipal = this.listaRecursos?.find(r => r.principal);
      if (!this.listaRecursos.length || !recursoPrincipal) {
        this.listaRecursos.push(this.criarRecursoPrincipal())
      }

      this.entidadeForm.get('historicos').setValue(this.listaHistoricos);
      this.entidadeForm.get('comissoes').setValue(this.listaComissoes);
      this.entidadeForm.get('recursos').setValue(this.listaRecursos);
      this.entidadeForm.get('aditamentos').setValue(this.listaAditamentos);
      this.entidadeForm.get('situacoes').setValue(this.listaSituacoes);
    } catch (e) {
      this.messageService.add({ severity: 'warn', summary: 'Validação', detail: e });
      throw e;
    }
  }

  protected afterSubmit(entidade: Convenio): void {
    // Atualiza a lista atual para que não fique enviando duplicatas
    this.handleChange({ index: 2 });
    this.handleChange({ index: 4 });
    this.handleChange({ index: 6 });

    this.loadResource();
    window.scrollTo(0, 0);
    success('Registro salvo com sucesso!');
  }

  private carregarAutoCompletes() {
    // autocomplete para unidade
    this.unidadeAutoComplete = new EddyAutoComplete(this.entidadeForm.get('unidade'), this.unidadeService,
      'id', ['codigo', 'nome'], { ppa_id: this.login.ppa.id, orderBy: 'nome' }, { number: ['codigo'], text: ['codigo', 'nome'] }
    );
    // autocomplete para favorecido
    this.favorecidoAutoComplete = new EddyAutoComplete(this.entidadeForm.get('favorecido'), this.favorecidoService,
      'id', ['cpf_cnpj', 'nome'], { cidade_id: this.login.cidade.id, relations: 'tipo', orderBy: 'nome' }, { number: ['id', 'cpf_cnpj'], text: ['nome'] }
    );
    // autocomplete para recurso
    this.recursoAutoComplete = new EddyAutoComplete(this.entidadeForm.get('recurso'), this.recursoService,
      'id', ['codigo', 'nome'], { nivel: 0, cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['codigo'], text: ['codigo', 'nome'] },
      () => {
        if (this.entidadeForm.get('recurso')?.value?.['codigo'] === '02') {
          this.entidadeForm.get('origem').setValue('E');
          this.bloquearOrigemPeloRecurso = true;
        } else if (this.entidadeForm.get('recurso')?.value?.['codigo'] === '05') {
          this.entidadeForm.get('origem').setValue('U');
          this.bloquearOrigemPeloRecurso = true;
        } else {
          this.bloquearOrigemPeloRecurso = false;
        }
      }
    );
    // autocomplete para aplicacao
    this.aplicacaoAutoComplete = new EddyAutoComplete(this.entidadeForm.get('aplicacao'), this.recursoService,
      'id', ['codigo', 'nome'], { nivel: 1, cidade_id: this.login.cidade.id, orderBy: 'nome' }, { text: ['codigo', 'nome'] }
    );
    // autocomplete para aplicacao variavao
    this.aplicacaoVariavelAutoComplete = new EddyAutoComplete(this.entidadeForm.get('aplicacao_variavel'), this.recursoService,
      'id', ['codigo', 'nome'], { nivel: 2, cidade_id: this.login.cidade.id, 'OR': 'ativo$eq=true;!;!;ativo$null=true', orderBy: 'nome' }, { number: ['codigo'], text: ['codigo', 'nome'] }
    );
    this.recursoContraAutoComplete = new EddyAutoComplete(this.entidadeForm.get('recurso_contra'), this.recursoService,
      'id', ['codigo', 'nome'], { nivel: 0, cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['codigo'], text: ['codigo', 'nome'] }
    );
    // autocomplete para aplicacao
    this.aplicacaoContraAutoComplete = new EddyAutoComplete(this.entidadeForm.get('aplicacao_contra'), this.recursoService,
      'id', ['codigo', 'nome'], { nivel: 1, cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['codigo'], text: ['codigo', 'nome'] }
    );
    // autocomplete para aplicacao variavao
    this.aplicacaoVariavelContraAutoComplete = new EddyAutoComplete(this.entidadeForm.get('aplicacao_variavel_contra'), this.recursoService,
      'id', ['codigo', 'nome'], { nivel: 2, cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['codigo'], text: ['codigo', 'nome'] }
    );
  }

  async handleChange(e) {
    var index = e.index;
    if (index === 1 && this.entidade.id) {
      this.alteracaoService.filtrar(0, -1, {
        'convenio.id': this.entidade.id,
        relations: 'convenio,convenio.tipo_convenio,tipo_convenio'
      }).pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (data: any) => {
            this.listaAlteracoes = data ? data.content : new Array<ConvenioAlteracao>();
          }, e => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: e }));
    } else if (index === 2 && this.entidade.id) {
      // Fontes de recurso ------------------------------------------------------------------
      this.convenioRecursoService.filtrar(0, -1, {
        'convenio.id': this.entidade.id,
        relations: 'convenio,recurso,aplicacao,aplicacao_variavel,recurso_contra,aplicacao_contra,aplicacao_variavel_contra'
      }).pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (data: any) => {
            this.listaRecursos = data ? data.content : new Array<ConvenioRecurso>();
          }, e => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: e }));
    } else if (index === 3 && this.entidade.id) {
      this.convenioRecursoService.obterRelacionamentosFichas(this.entidade.id, this.entidade.orgao.id).pipe(takeUntil(this.unsubscribe))
        .subscribe(res => {
          this.listaFichasDespesas = [];
          this.listaFichasReceitas = [];
          for (const item of res) {
            if (item.especie == 'receita') {
              this.listaFichasReceitas.push(item);
            } else {
              this.listaFichasDespesas.push(item);
            }
          }
        });
    } else if (index === 4 && this.entidade.id) {
      // Aditamentos  ----------------------------------------------------------------------
      this.aditamentoService.filtrar(0, -1, {
        'convenio.id': this.entidade.id, relations: 'convenio,convenio.tipo_convenio'
      }).pipe(takeUntil(this.unsubscribe)).subscribe((data: any) => {
        this.listaAditamentos = data ? data.content : new Array<ConvenioAditamento>();
      }, e => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: e }));
    } else if (index === 5 && this.entidade.id) {
      // reajustes  -------------------------------------------------------------------------
      this.reajusteService.filtrar(0, -1, {
        'convenio.id': this.entidade.id, relations: 'convenio'
      }).pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (data: any) => {
            this.listaReajustes = data ? data.content : new Array<ConvenioReajuste>();
          }, e => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: e }));
    } else if (index === 6 && this.entidade.id) {
      // prestação de contas ---------------------------------------------------------------
      // if (this.entidade.tipo_fornecedor === 'F') {
      let res = await this.situacaoService.filtrar(0, -1, {
        'convenio.id': this.entidade.id,
        relations: 'itens,usuario,convenio,convenio.orgao,convenio.orgao.cidade',
        orderBy: 'id$DESC'
      }).toPromise();
      this.listaSituacoes = res.content;
      // }
    } else if (index === 7 && this.entidade.id) {
      // licitações e contratos ----------------------------------------------------------
      this.convenioService.obterLicitacaoVinculada(this.entidade.id).pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (data: any) => {
            this.listaLicitacoes = data ? data : new Array<Licitacao>();
          }, e => this.messageService.add({ severity: 'error', summary: 'Atenção', detail: e }));
    }
  }

  public salvar(limparTela: boolean): void {
    this.submitForm(limparTela, (entidade: Convenio) => {
      this.listaSituacoes = Object.assign([], entidade['situacoes']);
      this.afterSubmit(entidade);
    });
  }

  public verificarFavorecidoTipoConvenio() {
    const tipoConvenio: TipoConvenio = this.entidadeForm.get('tipo_convenio').value;
    if (tipoConvenio.origem) {
      this.entidadeForm.get('tipo_fornecedor').setValue(tipoConvenio.origem);
      this.tipoConvenioPossuiOrigem = true;
      return;
    }

    this.tipoConvenioPossuiOrigem = false;
  }

  public dataContabilizacao() {
    if (this.entidadeForm.get('data_assinatura').value > new Date()) {
      this.entidadeForm.get('data_contabilizacao').setValue(this.entidadeForm.get('data_assinatura').value);
    } else {
      this.entidadeForm.get('data_contabilizacao').setValue(new Date());
    }
  }

  private criarRecursoPrincipal() {
    const model = new ConvenioRecurso()

    model.id = null
    model.principal = true
    model.recurso = this.entidadeForm.get('recurso').value
    model.aplicacao = this.entidadeForm.get('aplicacao').value
    model.aplicacao_variavel = this.entidadeForm.get('aplicacao_variavel').value
    model.recurso_contra = this.entidadeForm.get('recurso_contra').value
    model.aplicacao_contra = this.entidadeForm.get('aplicacao_contra').value
    model.aplicacao_variavel_contra = this.entidadeForm.get('aplicacao_variavel_contra').value

    return model
  }
}
